<template>
  <DragDialog
    title="编辑地图"
    :width="600"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="edit-map-box">
      <div class="service-name-box">
        <div class="name-box dialog-label">服务名称</div>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入服务名称"
            v-model="serviceName" />
        </div>
      </div>
      <div
        class="preview-box"
        v-if="isMapVisible()">
        <div class="title dialog-label">服务预览</div>
        <div
          id="mapbox-map"
          class="map-container" />
        <div class="bbox-form-box">
          <div class="common-checkbox-box">
            <el-checkbox
              class="checkbox-primary"
              v-model="bboxForm.enableCoverage"
              @change="checkboxChange">
              启用有效区域限制
            </el-checkbox>
          </div>
          <div class="effective-coverage-input-box">
            <div class="compass-box">
              <div class="compass-outer-circle">
                <img :src="require('@/assets/icon/compass.png')" />
              </div>
            </div>
            <el-form
              ref="bboxForm"
              :model="bboxForm"
              :rules="rules">
              <div class="effective-top-box">
                <el-form-item prop="effectiveCoverageTop">
                  <div class="common-input-box">
                    <el-input
                      class="input-outerborder-primary"
                      size="small"
                      @change="value => inputChange('top', value)"
                      v-model="bboxForm.effectiveCoverageTop">
                      <template slot="prepend">上</template>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
              <div class="effective-left-box">
                <el-form-item prop="effectiveCoverageLeft">
                  <div class="common-input-box">
                    <el-input
                      class="input-outerborder-primary"
                      size="small"
                      @change="value => inputChange('left', value)"
                      v-model="bboxForm.effectiveCoverageLeft">
                      <template slot="prepend">左</template>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
              <div class="effective-bottom-box">
                <el-form-item prop="effectiveCoverageDown">
                  <div class="common-input-box">
                    <el-input
                      class="input-outerborder-primary"
                      size="small"
                      @change="value => inputChange('bottom', value)"
                      v-model="bboxForm.effectiveCoverageDown">
                      <template slot="prepend">下</template>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
              <div class="effective-right-box">
                <el-form-item prop="effectiveCoverageRight">
                  <div class="common-input-box">
                    <el-input
                      class="input-outerborder-primary"
                      size="small"
                      @change="value => inputChange('right', value)"
                      v-model="bboxForm.effectiveCoverageRight">
                      <template slot="prepend">右</template>
                    </el-input>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div
        class="dialog-box-primary"
        v-else>
        <div class="common-empty-box">
          <bj-empty
            :image="require('@/assets/img/no-data.png')"
            class="empty-page">
            <template slot="description">
              <div class="text-box empty-text">
                高程影像无法直接预览，需在场景中与其他WMTS底图叠加显示
              </div>
            </template>
          </bj-empty>
        </div>
      </div>
    </div>
    <div class="common-button-box dialog-footer">
      <el-button
        size="small"
        class="normal-btn gr8 primary-ang-btn"
        @click="reset"
        >重置</el-button
      >
      <el-button
        size="small"
        type="primary"
        class="primary-btn primary-ang-btn"
        @click="saveData"
        >保存</el-button
      >
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import * as turf from '@turf/turf'
import BBox from '@/utils/bbox'

import { updateWmtsConfig } from '@/service/interface'

const mapboxgl = window.mapboxgl
const MapboxLanguage = window.MapboxLanguage
const MapboxGeocoder = window.MapboxGeocoder
// prettier-ignore
mapboxgl.accessToken = "pk.eyJ1IjoiY2htMTc4MSIsImEiOiJjaXI0YWk3a3QwMWx5ZnBubTFuY3d2enZvIn0.zDEUyiEq9gGb69B8qki9Tg";

export default {
  data() {
    // 有效区域验证
    const validTopRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) > this.bboxForm.effectiveCoverageDown) {
        return callback()
      } else {
        callback(new Error('上有效区应大于下有效区'))
      }
    }
    const validBottomRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) < this.bboxForm.effectiveCoverageTop) {
        return callback()
      } else {
        callback(new Error('下有效区应小于上有效区'))
      }
    }
    const validLeftRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) < this.bboxForm.effectiveCoverageRight) {
        return callback()
      } else {
        callback(new Error('左有效区应小于右有效区'))
      }
    }
    const validRightRule = (rule, value, callback) => {
      if (!this.bboxForm.enableCoverage) return callback()
      if (Number(value) > this.bboxForm.effectiveCoverageLeft) {
        return callback()
      } else {
        callback(new Error('右有效区应大于左有效区'))
      }
    }

    return {
      serviceName: '',
      mapServiceUrl: '',
      bboxForm: {
        enableCoverage: false,
        effectiveCoverageTop: '0',
        effectiveCoverageDown: '0',
        effectiveCoverageLeft: '0',
        effectiveCoverageRight: '0'
      },
      rules: {
        effectiveCoverageTop: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
            message: '请输入有效值'
          },
          { validator: validTopRule }
        ],
        effectiveCoverageDown: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/,
            message: '请输入有效值'
          },
          { validator: validBottomRule }
        ],
        effectiveCoverageLeft: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
            message: '请输入有效值'
          },
          { validator: validLeftRule }
        ],
        effectiveCoverageRight: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            pattern:
              /^(-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/,
            message: '请输入有效值'
          },
          { validator: validRightRule }
        ]
      }
    }
  },
  props: {
    visible: Boolean,
    mapInfo: Object,
    refreshTable: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.init()
        })
      } else {
        this.bbox && this.bbox.uninstall()
        this.bbox = null
      }
    }
  },
  methods: {
    init() {
      this.serviceName = this.mapInfo.serviceName
      if (this.isMapVisible()) {
        this.mapServiceUrl = this.mapInfo.fmtStr_Web

        let bboxForm = {
          enableCoverage: this.mapInfo.enableCoverage,
          effectiveCoverageTop: this.mapInfo.effectiveCoverageTop,
          effectiveCoverageDown: this.mapInfo.effectiveCoverageDown,
          effectiveCoverageLeft: this.mapInfo.effectiveCoverageLeft,
          effectiveCoverageRight: this.mapInfo.effectiveCoverageRight
        }
        this.bboxForm = bboxForm

        this.initMap()
      }
    },
    checkboxChange(value) {
      if (value) {
        this.bbox.start()
      } else {
        this.bbox && this.bbox.reset()
        this.bboxForm.effectiveCoverageLeft = ''
        this.bboxForm.effectiveCoverageDown = ''
        this.bboxForm.effectiveCoverageRight = ''
        this.bboxForm.effectiveCoverageTop = ''
      }
    },
    inputChange(type, value) {
      let updateFlag = true
      this.$refs.bboxForm.validateField(
        [
          'effectiveCoverageTop',
          'effectiveCoverageDown',
          'effectiveCoverageRight',
          'effectiveCoverageLeft'
        ],
        error => {
          if (error) {
            updateFlag = false
          }
        }
      )
      if (updateFlag) {
        this.bbox.updateGeometry(type, value)
      }
    },
    reset() {
      this.serviceName = this.mapInfo.serviceName
      this.mapServiceUrl = this.mapInfo.fmtStr_Web

      let bboxForm = {
        enableCoverage: this.mapInfo.enableCoverage,
        effectiveCoverageTop: this.mapInfo.effectiveCoverageTop,
        effectiveCoverageDown: this.mapInfo.effectiveCoverageDown,
        effectiveCoverageLeft: this.mapInfo.effectiveCoverageLeft,
        effectiveCoverageRight: this.mapInfo.effectiveCoverageRight
      }
      this.bboxForm = bboxForm

      let layerInfo = {
        dataSetId: this.mapInfo.dataSetId,
        mapServiceUrl: this.mapServiceUrl
      }
      this.addLayer(layerInfo, 'bbox-area')
      this.updateEffectiveCoverage()
      this.bbox.stop()
    },
    saveData() {
      let params = this.getUpdateParams()
      updateWmtsConfig(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('修改配置成功！')
          this.refreshTable()
          this.reset()
          this.closeDialog()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    getUpdateParams() {
      let params = {
        dataSetId: this.mapInfo.dataSetId,
        serviceName: this.serviceName,
        enableCoverage: this.bboxForm.enableCoverage,
        effectiveCoverageTop: this.bboxForm.effectiveCoverageTop,
        effectiveCoverageDown: this.bboxForm.effectiveCoverageDown,
        effectiveCoverageLeft: this.bboxForm.effectiveCoverageLeft,
        effectiveCoverageRight: this.bboxForm.effectiveCoverageRight
      }
      return params
    },
    initMap() {
      this.map = new mapboxgl.Map({ container: 'mapbox-map' })
      this.map.addControl(new MapboxLanguage({ defaultLanguage: 'zh' }))
      let accessToken = mapboxgl.accessToken
      let mapboxGeocoder = new MapboxGeocoder({ accessToken, mapboxgl })
      this.map.addControl(mapboxGeocoder, 'top-left')

      this.map.on('load', this.updateEffectiveCoverage)

      let layerInfo = {
        dataSetId: this.mapInfo.dataSetId,
        mapServiceUrl: this.mapServiceUrl
      }
      this.addLayer(layerInfo)
    },
    addLayer(layerInfo, beneathLayerId) {
      if (this.map.getStyle()) {
        let layers = this.map.getStyle().layers
        let layer = layers.filter(el => !el.id.includes('bbox'))
        if (layer.length) {
          this.map.removeLayer(layer[0].id)
          this.map.removeSource(layer[0].id)
        }
      }
      this.setCenterAndZoom(layerInfo.mapServiceUrl)
      this.map.addLayer(
        {
          id: layerInfo.dataSetId,
          type: 'raster',
          source: {
            type: 'raster',
            tiles: [layerInfo.mapServiceUrl],
            tileSize: 256
          },
          paint: {}
        },
        beneathLayerId
      )
    },
    setCenterAndZoom(mapServiceUrl) {
      if (mapServiceUrl.includes('img_c')) {
        this.map.setCenter([115.038442, 77.293467])
      } else {
        this.map.setCenter([108.992513, 37.72948])
      }
      this.map.setZoom(2)
    },
    updateEffectiveCoverage() {
      this.map.resize()
      if (!this.bbox) {
        this.bbox = new BBox(this.map, this.getBBox)
      }
      if (this.bboxForm.enableCoverage) {
        let bbox = [
          Number(this.bboxForm.effectiveCoverageLeft),
          Number(this.bboxForm.effectiveCoverageDown),
          Number(this.bboxForm.effectiveCoverageRight),
          Number(this.bboxForm.effectiveCoverageTop)
        ]
        this.bbox.updateBBoxPolygon(bbox)

        this.bbox.start()
        this.bbox.editFlag = true
        this.bbox.selectPoint = null
      } else {
        this.bbox.reset()
      }
    },
    getBBox(geometry) {
      let bbox = turf.bbox(geometry)
      this.bboxForm.effectiveCoverageLeft = Number(bbox[0]).toFixed(6)
      this.bboxForm.effectiveCoverageDown = Number(bbox[1]).toFixed(6)
      this.bboxForm.effectiveCoverageRight = Number(bbox[2]).toFixed(6)
      this.bboxForm.effectiveCoverageTop = Number(bbox[3]).toFixed(6)
    },
    clearForm() {
      this.serviceName = ''
      this.mapServiceUrl = ''
      this.bboxForm = {
        enableCoverage: false,
        effectiveCoverageTop: '0',
        effectiveCoverageDown: '0',
        effectiveCoverageLeft: '0',
        effectiveCoverageRight: '0'
      }
    },
    destroyMap() {
      this.bbox.reset()

      if (this.map.getStyle()) {
        let layers = this.map.getStyle().layers
        layers.forEach(layer => {
          this.map.removeLayer(layer.id)
          this.map.removeSource(layer.source)
        })
      }

      this.map.off('load', this.updateEffectiveCoverage)

      this.map.remove()
      this.map = null
    },
    isMapVisible() {
      if (this.mapInfo) {
        let { layerResType } = this.mapInfo
        if (layerResType === 'height') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    cancel() {
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.input-outerborder-primary {
  :deep(.el-input-group__prepend) {
    background-color: var(--wmts-mapview-effective-bg-color);
    border-color: var(--wmts-mapview-effective-border-color);
    color: var(--wmts-mapview-effective-prepend-color);
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding: 0 13px;
  }
  :deep(.el-input__inner) {
    color: var(--wmts-mapview-effective-color);
    border-color: var(--wmts-mapview-effective-border-color);
    height: 30px;
    line-height: 30px;
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    width: 64px;
  }
}
.edit-map-box {
  color: var(--default-color);
  max-height: 76vh;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  &::-webkit-scrollbar {
    display: none;
  }

  .service-name-box {
    display: flex;
    margin-bottom: 16px;

    .name-box {
      line-height: 32px;
      &::before {
        content: '*';
        color: #f56c6c;
        margin-right: 5px;
      }
    }

    .common-input-box {
      flex-grow: 1;
      margin-left: 10px;
    }
  }

  .preview-box {
    .title {
      position: relative;
      padding-left: 8px;
      margin-bottom: 16px;

      &::before {
        display: block;
        content: '';
        width: 4px;
        height: 16px;
        position: absolute;
        top: 3px;
        left: 0;
        background: var(--base-primary-bgColor);
      }
    }

    .map-container {
      position: relative;
      height: 320px;
      border-radius: 8px;
      border: 1px solid var(--wmts-mapview-map-border-color);
    }

    .bbox-form-box {
      position: relative;
      padding: 15px 0px;

      .common-checkbox-box {
        .el-checkbox {
          color: var(--default-color);
        }
      }

      .effective-coverage-input-box {
        position: relative;
        height: 270px;

        .compass-box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 120px;
          width: 120px;
          background: var(--wmts-mapview-compass-bg-color);
          border-radius: 50%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          .compass-outer-circle {
            border-radius: 50%;
            margin-top: 8px;

            img {
              width: 84px;
              height: 84px;
              object-fit: contain;
            }
          }
        }

        .common-input-box {
          width: 104px;

          :deep(.el-input-group__prepend) {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }
        }

        .effective-top-box {
          position: absolute;
          top: 30px;
          left: 50%;
          transform: translateX(-50%);

          /deep/ .el-form-item__error {
            width: 145px;
            top: 0px;
            left: 107px;
            line-height: 25px;
            text-align: left;
          }
        }

        .effective-left-box {
          position: absolute;
          top: 120px;
          left: 106px;

          /deep/ .el-form-item__error {
            width: 145px;
            top: 24px;
            left: 50px;
            line-height: 25px;
            text-align: left;
          }
        }

        .effective-bottom-box {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);

          /deep/ .el-form-item__error {
            width: 145px;
            top: 0px;
            left: 107px;
            line-height: 25px;
            text-align: left;
          }
        }

        .effective-right-box {
          position: absolute;
          top: 120px;
          right: 105px;

          /deep/ .el-form-item__error {
            width: 145px;
            top: 24px;
            left: 50px;
            line-height: 25px;
            text-align: left;
          }
        }
      }
    }
  }

  .occupation-map-box {
    height: calc(100% - 40px);
    margin: 10px 0px;
  }
}

.dialog-primary-body {
  .common-button-box {
    width: 100%;
    margin-top: 16px;
    padding-top: 10px;
    margin-left: -16px;
    text-align: right;
    border-top: 1px solid var(--dialog-footer-border-color);
    box-sizing: content-box;
    padding-right: 32px !important;
  }
}
</style>
